import React, { useState, useEffect, useRef } from "react"
import {
  Row,
  Col,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  FormFeedback,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import classnames from "classnames"
import { Link } from "react-router-dom"
import LoadingButton from "../../../components/Common/LoadingButton"
import { UFDate, UFEditor, UFInput, UFInputNumber } from "../../../components/Common/Fields/Input"
import { useForm, FormProvider, useFieldArray } from "react-hook-form"
import { Form, FormGroup, Label } from "reactstrap"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import closeIcon from "../../../assets/icons/close.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { fetchProduct } from "../../../services/Inventory/inventory"
import CustomerType from "../../../components/Common/chooseFields/customerType"
import BalanceTypeDrop from "../../../components/Common/chooseFields/balanceType"
import CreditPeriod from "../../../components/Common/chooseFields/creditPeriod"
import {
  fetchCustomer,
  postCustomer,
} from "../../../services/projectManager/customer"
import PhoneInputField from "../../../components/Common/Fields/phoneInput"
import { getCustomerList } from "../../../services/Settings/dropdown"
import { getCode } from "../../../services/inventory"
import TrashIcon from "../../../assets/icons/iconComponents/trashIcon"
import FinanceGroupType from "../../../components/Common/chooseFields/financeGroupType"
import EditFinanceGroup from "../../Finance/groups/edit"
import CreditPaymentMethod from "../../../components/Common/chooseFields/creditPayment"
import DebitCreditDrop from "../../../components/Common/chooseFields/debitCredit"
import moment from "moment"

const customerSchema = yup.object().shape({
  customer_type: yup.mixed().required("Customer Type is Required"),
  customer_name: yup
    .string()
    .notRequired()
    .required("Customer Name is Required"),
  contact_person: yup.string().notRequired(), //.required("Contact Person is Required"),
  customer_number: yup.string().notRequired(),
  // .required("Customer Number is Required")
  // .matches(/^([+]?)?[0-9]+$|^$/, "Contact Number must be only digits")
  // .min(9, "Minimum limit is 9")
  // .max(15, "Maximum limit is 15"),
  // contact_person_designation: yup
  //   .string(),
  // .required("Contact Person Designation is Required"),
  email_id: yup.string().notRequired().email("Must be a valid Email"),
  // .required("Email ID is Required"),
  customer_name_two: yup.string().notRequired(),
  customer_number_two: yup
    .string()
    .notRequired()
    .matches(/^([+]?)?[0-9]+$|^$/, "Contact Number must be only digits")
    // .min(9, "Minimum limit is 9")
    .max(15, "Maximum limit is 15"),
  contact_person_designation_two: yup.string().notRequired(),
  creditperiod: yup.mixed().notRequired(), //.required("Credit Period is Required"),
  account_group_id: yup.mixed().required("Nature of Account is Required"),
  // fax_number: yup
  //   .string()
  //   .matches(/^([+]?)?[0-9]+$|^$/, "Fax Number must be only digits")
  //   .required("Fax Number is Required"),
  // address: yup.string(), //.required("Address is Required"),
  opening_balance: yup
    .string()
    .notRequired()
    .matches(/^\d+(\.\d+)?$/, {
      message: "Opening balance must be a positive number",
      excludeEmptyString: true,
    })
    .test("is-positive", "Opening balance cannot be negative", value => {
      if (!value) return true // Allow empty
      return parseFloat(value) >= 0
    }),
    voucher_contra_partial_pay: yup
          .array()
          .of(
            yup.object().shape({
              code: yup.string().trim().required("Reference Number is Required"),
              amount: yup
                .number()
                .typeError("Amount must be a number")
                .min(0, "Amount must be a positive number")
                .transform(value => (isNaN(value) ? undefined : value)),
              date: yup
                .date()
                .typeError("Date must be a valid date")
                .required("Date is Required"),
              due_date: yup
                .date()
                .typeError("Due Date must be a valid date")
                .required("Due Date is Required"),
            })
          )
          .when(["opening_balance", "account_group_id"], {
            is: (opening_balance, account_group_id) =>
              opening_balance > 0 && [13, 22].includes(account_group_id),
            then: schema => schema.min(1, "At least one partial payment is required"),
            otherwise: schema => schema.notRequired(),
          }),
})
const Edit = ({
  loading,
  onUpdate,
  close,
  getEditValue,
  updateCustomerList,
  editValue,
  props,
  formId = "customer-form",
  isOpen = false,
}) => {
  const formMethods = useForm({
    resolver: yupResolver(customerSchema),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      customer_type: null,
      customer_name: "",
      contact_person: "",
      customer_number: "",
      contact_person_designation: "",
      creditperiod: null,
      email_id: "",
      customer_name_two: "",
      contact_person_designation_two: "",
      customer_number_two: "",
      address: "",
      opening_balance: 0,
      balance_type: null,
      code_edit: 0,

      account_group_id: null,
    },
  })
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = formMethods
  // const methods = useForm({
  //   resolver: yupResolver(schema),
  // })
  const [isLoading, setIsLoading] = useState(false)
  const drCrRefs = useRef([])
  const now = moment()
  const desimalrange = localStorage.getItem("desimalrange")
  const [showGroupModal, setShowGroupModal] = useState(false)
  const [isModal, setModal] = useState(false)
  const [veRemove, setVERemove] = useState([])

  useEffect(() => {
    const getUniqueCode = async () => {
      const response = await getCode("customer_code", "Customers", "Customers")
      if (editValue?.id == "" || editValue == undefined) {
        setValue("customer_code", response?.code?.code)
      }
      setValue("code_edit", response?.code?.manualoverride)
    }
    getUniqueCode()
  }, [])

  useEffect(() => {
    console.log(`getEditValue`, editValue)

    if (getEditValue) {
      console.log("edit", getEditValue)
      reset({
        ...getEditValue?.data,
        customer_code: getEditValue?.data?.customer_code
          ? getEditValue?.data?.customer_code
          : "",
        customer_type: {
          label: getEditValue?.data?.customer_type?.label,
          value: getEditValue?.data?.customer_type?.id,
          id: getEditValue?.data?.customer_type?.id,
        },
        creditperiod:  getEditValue?.data?.credit_period?.id ? {
                value: getEditValue?.data?.credit_period?.id,
                id: getEditValue?.data?.credit_period?.id,
                label:
                  getEditValue?.data?.credit_period?.period == 0
                    ? "Immediate"
                    : `${getEditValue?.data?.credit_period?.period} ${
                        getEditValue?.data?.credit_period?.unit == "days"
                          ? getEditValue?.data?.credit_period?.period > 1
                            ? "Days"
                            : "Day"
                          : getEditValue?.data?.credit_period?.period > 1
                          ? "Months"
                          : "Months"
                      }`,
                ...getEditValue?.data?.credit_period,
              } : null,
        contact_person_designation_two:
          getEditValue?.data?.contact_person_designation_two != null
            ? getEditValue?.data?.contact_person_designation_two
            : "",
        customer_number_two:
          getEditValue?.data?.customer_number_two != null
            ? getEditValue?.data?.customer_number_two
            : "",
        opening_balance: getEditValue?.data?.ledger?.opening_balance
          ? getEditValue?.data?.ledger?.opening_balance
          : 0,
        balance_type: {
          value: getEditValue?.data?.ledger?.balance_type,
          label: getEditValue?.data?.ledger?.balance_type,
          id: getEditValue?.data?.ledger?.balance_type,
        },
        customer_number:
          getEditValue?.data?.customer_number != null
            ? getEditValue?.data?.customer_number
            : "",
        account_group_id: getEditValue?.data?.ledger?.account_group?.id
          ? {
            value: getEditValue?.data?.ledger?.account_group?.id,
            label: getEditValue?.data?.ledger?.account_group?.name,
          }
          : null,
      })
      if (
        getEditValue?.data?.contact_person_two ||
        getEditValue?.data?.customer_number_two ||
        getEditValue?.data?.contact_person_designation_two
      ) {
        setShowAdditionalContacts(true)
      }
    }
  }, [getEditValue])

  const [showAdditionalContacts, setShowAdditionalContacts] = useState(false)
  const handleRegistration = async data => {

    const totalCheck = calculateCreditDebitDifference(
      data?.voucher_contra_partial_pay || []
    )

    if (Number(data?.opening_balance) > 0 && !isModal) {
      setModal(true)
      if (
        Number(data?.opening_balance) -
        Number(
          data?.balance_type?.value == "debit"
            ? Number(totalCheck?.totalDebit || 0) -
            Number(totalCheck?.totalCredit || 0)
            : Number(totalCheck?.totalCredit || 0) -
            Number(totalCheck?.totalDebit || 0)
        ) !=
        0
      ) {
        contraPartialListAppend({
          account_id: data?.credit_id?.value,
          debit: 0,
          credit: 0,
          amount: Math.abs(
            Number(watch("opening_balance")) -
            // Number(totalCheck?.difference || 0)
            Number(
              data?.balance_type?.value == "debit"
                ? Number(totalCheck?.totalDebit || 0) -
                Number(totalCheck?.totalCredit || 0)
                : Number(totalCheck?.totalCredit || 0) -
                Number(totalCheck?.totalDebit || 0)
            )
          ).toFixed(desimalrange || 2),
          type: data?.balance_type?.value
            ? {
              label: data?.balance_type?.value == "debit" ? "Dr" : "Cr",
              value: data?.balance_type?.value,
            }
            : { label: "Cr", value: "credit" },
          // Number(data?.opening_balance) < Number(totalCheck?.difference)
          //   ? { label: "Dr", value: "debit" }
          //   : { label: "Cr", value: "credit" },
          due_date: moment(now, "DD-MM-MMMM").toDate(),
          date: moment("31-12-2024", "DD-MM-YYYY").toDate(),
          ref_id: {
            label: "New Ref",
            value: 3,
          },
        })
      }
    } else if (
      Number(data?.opening_balance || 0) -
      Number(
        data?.balance_type?.value == "debit"
          ? Number(totalCheck?.totalDebit || 0) -
          Number(totalCheck?.totalCredit || 0)
          : Number(totalCheck?.totalCredit || 0) -
          Number(totalCheck?.totalDebit || 0)
      ) !=
      0 &&
      isModal
    ) {
      // setModal(true)
      if (
        Number(data?.opening_balance) -
        Number(
          data?.balance_type?.value == "debit"
            ? Number(totalCheck?.totalDebit || 0) -
            Number(totalCheck?.totalCredit || 0)
            : Number(totalCheck?.totalCredit || 0) -
            Number(totalCheck?.totalDebit || 0)
        ) !=
        0
      ) {
        contraPartialListAppend({
          account_id: data?.credit_id?.value,
          debit: 0,
          credit: 0,
          amount: Math.abs(
            Number(watch("opening_balance")) -
            // Number(totalCheck?.difference || 0)
            Number(
              data?.balance_type?.value == "debit"
                ? Number(totalCheck?.totalDebit || 0) -
                Number(totalCheck?.totalCredit || 0)
                : Number(totalCheck?.totalCredit || 0) -
                Number(totalCheck?.totalDebit || 0)
            )
          ).toFixed(desimalrange || 2),
          type:
            data?.balance_type?.value == "debit" &&
              Number(totalCheck?.totalDebit || 0) <
              Number(data?.opening_balance || 0)
              ? { label: "Dr", value: "debit" }
              : data?.balance_type?.value == "credit" &&
                Number(totalCheck?.totalCredit || 0) <
                Number(data?.opening_balance || 0)
                ? { label: "Cr", value: "credit" }
                : data?.balance_type?.value == "debit" &&
                  Number(totalCheck?.totalDebit || 0) >
                  Number(data?.opening_balance || 0)
                  ? { label: "Cr", value: "credit" }
                  : { label: "Dr", value: "debit" },

          // Number(data?.opening_balance) < Number(totalCheck?.difference)
          //   ? { label: "Dr", value: "debit" }
          //   : { label: "Cr", value: "credit" },
          // type:
          //   Number(data?.opening_balance) < Number(totalCheck?.difference)
          //     ? { label: "Dr", value: "debit" }
          //     : { label: "Cr", value: "credit" },
          due_date: moment(now, "DD-MM-MMMM").toDate(),
          date: moment("31-12-2024", "DD-MM-YYYY").toDate(),
          ref_id: {
            label: "New Ref",
            value: 3,
          },
        })
      }
    } else {
      const voucherEntry = data?.voucher_contra_partial_pay?.map(item => ({
        voucher_id: 20,
        ref_number: item?.code,
        due_date: moment(item?.due_date).format("YYYY-MM-DD"),
        date: moment(item?.date).format("YYYY-MM-DD"),
        amount: item?.amount,
        type: item?.type?.value,
        voucherType: "Opening Balance",
        voucher_entry_id: item?.voucher_entry_id,
      }))
      try {
        setIsLoading(true)
        const response = await postCustomer({
          ...data,
          voucherEntry: voucherEntry,
          customer_type: data?.customer_type?.id,
          balance_type: data?.balance_type?.value,
          creditperiod: data?.creditperiod?.id,
          opening_balance: data?.opening_balance ? data?.opening_balance : 0,
          account_group_id: data?.account_group_id?.value,
        })

        if (response?.status) {
          toastSuccess(response?.message)

          onUpdate(response.data?.id)

          const updatedList = await getCustomerList()
          if (updatedList?.status) {
            updateCustomerList(updatedList.data)
          }
          close()
        }
      } catch (err) {
        toastError(err?.message)
      } finally {
        setIsLoading(false)
      }
    }
  }

  const {
    fields: contraFieldsPartial,
    append: contraPartialListAppend,
    remove: contraPartialListRemove,
  } = useFieldArray({
    control,
    name: "voucher_contra_partial_pay",
  })

  const toggleSelect = () => setModal(!isModal)

  const toggleSelectModal = () => {

    if (!getEditValue?.id) {
      setValue(`voucher_contra_partial_pay`, [])
    }

    const removeIds = watch("voucher_contra_partial_pay")?.map((_, i) => i)

    if (removeIds?.length > 1) {
      ;[...removeIds].reverse().forEach(index => contraPartialListRemove(index))
    }

    console.log(`removeIds`, removeIds)
    setModal(!isModal)
  }

  const handlePartialRemove = e => {
    setVERemove(prevVERemove => [...prevVERemove, e])
  }

  const calculateCreditDebitDifference = (entries = []) => {
    let totalCredit = 0
    let totalDebit = 0

    entries.forEach(({ amount = 0, type }) => {
      const amt = Number(amount) || 0
      const typeChk = type?.value

      if (typeChk === "credit") {
        totalCredit += amt
      } else if (typeChk === "debit") {
        totalDebit += amt
      }
    })

    totalCredit = Number(totalCredit.toFixed(desimalrange || 2))
    totalDebit = Number(totalDebit.toFixed(desimalrange || 2))
    const difference = Number(
      Math.abs(totalCredit - totalDebit).toFixed(desimalrange || 2)
    )

    return {
      totalCredit,
      totalDebit,
      difference,
    }
  }

  return (
    <>
      <OffcanvasHeader toggle={close}>
        <div className="d-flex justify-content-between">
          <h5 className="editmodelheadtitle edittheamtitle">
            {getEditValue?.data?.id ? "Edit Customer" : "New Customer"}
          </h5>
        </div>
      </OffcanvasHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
            size="md"
          />
        </div>
      ) : (
        <OffcanvasBody>
          <FormProvider {...formMethods}>
            <Form
              id="customer-form"
              onSubmit={e => {
                e.preventDefault()
                e.stopPropagation()
                handleSubmit(handleRegistration)(e)
              }}
            >
              <Row>
                <Col sm={4}>
                  <FormGroup className="mb-4">
                    <Label>Code</Label>
                    <UFInput
                      control={control}
                      placeholder=""
                      name={"customer_code"}
                      invalid={!!errors.customer_code}
                      disabled={
                        watch("code_edit") == 0 ||
                          watch("code_edit") == undefined
                          ? true
                          : false
                      }
                    />
                    <FormFeedback invalid>
                      {errors.customer_code?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col sm={4}>
                  <FormGroup className="mb-4">
                    <Label>
                      Customer Type<span className="mandatory">*</span>
                    </Label>
                    <CustomerType
                      control={control}
                      name="customer_type"
                      invalid={!!errors.customer_type}
                      disabled={getEditValue?.data?.id}
                      placeholder={"Select Customer Type"}
                    />
                    <FormFeedback>{errors.customer_type?.message}</FormFeedback>
                  </FormGroup>
                </Col>
                {/* Rest of your form fields */}
                <Col sm={4}>
                  <FormGroup className="mb-4">
                    <Label>
                      Customer Name<span className="mandatory">*</span>
                    </Label>
                    <UFInput
                      control={control}
                      placeholder="Enter the Customer Name"
                      name={"customer_name"}
                      invalid={!!errors.customer_name}
                    />
                    <FormFeedback invalid>
                      {errors.customer_name?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col sm={4}>
                  <FormGroup className="mb-4">
                    <Label>Email ID</Label>
                    <UFInput
                      control={control}
                      placeholder="Enter the Email ID"
                      name={"email_id"}
                      invalid={!!errors.email_id}
                    />
                    <FormFeedback invalid>
                      {errors.email_id?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col lg={4}>
                  <FormGroup className="mb-4">
                    <Label>Opening Balance</Label>
                    <UFInput
                      control={control}
                      placeholder="Enter the Opening Balance"
                      name={"opening_balance"}
                      invalid={!!errors.opening_balance}
                    />
                    <FormFeedback invalid>
                      {errors.opening_balance?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col lg={4}>
                  <FormGroup>
                    <Label>Balance Type</Label>
                    <BalanceTypeDrop
                      control={control}
                      placeholder="Select Balance Type"
                      name={"balance_type"}
                      invalid={!!errors.balance_type}
                    />
                    <FormFeedback invalid>
                      {errors.balance_type?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col sm={4}>
                  <FormGroup className="mb-4">
                    <Label>Contact Person</Label>
                    <UFInput
                      control={control}
                      placeholder="Enter contact person's name"
                      name={"contact_person"}
                      invalid={!!errors.contact_person}
                    />
                    <FormFeedback invalid>
                      {errors.contact_person?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col sm={4}>
                  <FormGroup className="mb-4">
                    <Label>Contact Number</Label>
                    {/* <UFInput
                        control={control}
                        placeholder="Enter the Contact Number"
                        name={"customer_number"}
                        invalid={!!errors.customer_number}
                      /> */}
                    <PhoneInputField
                      control={control}
                      name={"customer_number"}
                      invalid={!!errors.customer_number}
                      countryCode={watch("countryCode")}
                      setValue={setValue}
                    />
                    <FormFeedback invalid>
                      {errors.customer_number?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col sm={4}>
                  <FormGroup className="mb-4">
                    <Label>Contact Person Designation</Label>
                    <UFInput
                      control={control}
                      placeholder="Enter the Contact Person Designation"
                      name={"contact_person_designation"}
                      invalid={!!errors.contact_person_designation}
                    />
                    <FormFeedback invalid>
                      {errors.contact_person_designation?.message}
                    </FormFeedback>
                    {!showAdditionalContacts && (
                      <button
                        type="button"
                        className="btn btn-link p-0 mt-2 ms-tomove-right"
                        onClick={() => setShowAdditionalContacts(true)}
                      >
                        + Add another contact
                      </button>
                    )}
                  </FormGroup>
                </Col>
                {showAdditionalContacts && (
                  <>
                    <Col sm={4}>
                      <FormGroup className="mb-4">
                        <Label>Contact Person 2</Label>
                        <UFInput
                          control={control}
                          placeholder="Enter contact person's name 2"
                          name={"contact_person_two"}
                          invalid={!!errors.contact_person_two}
                        />
                        <FormFeedback invalid>
                          {errors.contact_person_two?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={4}>
                      <FormGroup className="mb-4">
                        <Label>Contact Number 2</Label>
                        <PhoneInputField
                          control={control}
                          name={"customer_number_two"}
                          invalid={!!errors.customer_number_two}
                          countryCode={watch("countryCode")}
                          setValue={setValue}
                        />
                        <FormFeedback invalid>
                          {errors.customer_number_two?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={4}>
                      <FormGroup className="mb-4">
                        <Label>Contact Person Designation 2</Label>
                        <UFInput
                          control={control}
                          placeholder="Enter the Contact Person Designation 2"
                          name={"contact_person_designation_two"}
                          invalid={!!errors.contact_person_designation_two}
                          widthof={true}
                        />
                        <FormFeedback invalid>
                          {errors.contact_person_designation_two?.message}
                        </FormFeedback>
                        {showAdditionalContacts && (
                          <div
                            type="button"
                            className=" p-0 mt-0 trash-img trash-img-position-true"
                            onClick={() => {
                              setShowAdditionalContacts(false)
                              reset({
                                ...getValues(),
                                contact_person_two: "",
                                customer_number_two: "",
                                contact_person_designation_two: "",
                              })
                            }}
                          >
                            <TrashIcon size={20} />
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </>
                )}
                {/* <Col lg={4}>
                  <FormGroup className="mb-4">
                    <Label>Opening Balance</Label>
                    <UFInput
                      control={control}
                      placeholder="Enter the Opening Balance"
                      name={"opening_balance"}
                      invalid={!!errors.opening_balance}
                    />
                    <FormFeedback invalid>
                      {errors.opening_balance?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col> */}
                {/* <Col lg={4}>
                  <FormGroup>
                    <Label>Balance Type</Label>
                    <BalanceTypeDrop
                      control={control}
                      placeholder="Select Balance Type"
                      name={"balance_type"}
                      invalid={!!errors.balance_type}
                    />
                    <FormFeedback invalid>
                      {errors.balance_type?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col> */}
                <Col sm={4}>
                  <FormGroup className="mb-4">
                    <Label>Credit Period</Label>
                    <CreditPaymentMethod
                      control={control}
                      placeholder="Select Credit Period"
                      name={"creditperiod"}
                      invalid={!!errors.creditperiod}
                      target={".modal"}
                    // disable={true}
                    />
                    <FormFeedback invalid>
                      {errors.creditperiod?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col lg={4}>
                  <FormGroup>
                    <Label>
                      Nature Of Account
                      <span className="mandatory">*</span>
                    </Label>
                    <FinanceGroupType
                      control={control}
                      placeholder="Select the Nature Of Account"
                      name={"account_group_id"}
                      invalid={!!errors.account_group_id}
                      target={"body"}
                      showCreateOption={true}
                      onCreate={() => setShowGroupModal(true)}
                      // onSelectChange={e => handleNOA(e)}
                      refreshKey={showGroupModal}
                      parentChk={"31"}
                    />
                    <EditFinanceGroup
                      buttonLabel=""
                      className=""
                      show={showGroupModal}
                      onReset={() => setShowGroupModal(false)}
                      onUpdate={newGroup => {
                        setShowGroupModal(false)
                        if (newGroup) {
                          setValue(
                            "account_group_id",
                            {
                              label: newGroup.name,
                              value: newGroup.id,
                            },
                            { shouldValidate: true }
                          )
                        }
                      }}
                    />
                    <FormFeedback invalid>
                      {errors.account_group_id?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col sm={4}>
                  <FormGroup className="mb-4">
                    <Label>Address</Label>
                    <UFEditor
                      control={control}
                      placeholder="Enter the Address"
                      rows="3"
                      name={"address"}
                      invalid={!!errors.address}
                    />
                    <FormFeedback invalid>
                      {errors.address?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={close} // Close the offcanvas when clicked
                  >
                    Cancel
                  </button>
                  <LoadingButton
                    form="customer-form"
                    color="primary"
                    loading={isLoading}
                    disabled={isLoading}
                    type="submit"
                  >
                    {getEditValue?.data?.id ? "Update" : "Save"}
                  </LoadingButton>
                </div>{" "}
              </Row>
              <Modal
                isOpen={isModal}
                toggle={toggleSelect}
                size="xl"
                unmountOnClose={false}
                className="custom-modal-ht"
                backdrop={"static"}
              >
                <div>
                  {/* <div onKeyDown={onKeyDown}> */}
                  <ModalHeader className="custom-modal-header">
                    <div className="d-flex justify-content-between">
                      <h5 className="ms-2">Opening Balance Details </h5>
                      <img
                        src={closeIcon}
                        alt=""
                        onClick={toggleSelectModal}
                        width="10"
                        role="button"
                      />
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <Row className="mb-4">
                      <Col lg={12} className="mb-4">
                        <table className="estimation-table mb-4">
                          <thead>
                            <tr>
                              <th>Dr/Cr</th>
                              <th>Reference</th>
                              <th>Date</th>
                              <th>Due Date</th>
                              <th>Amount</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {contraFieldsPartial?.map((item, index) => (
                              <>
                                <tr key={`purchase${item.id || index}`}>
                                  <td>
                                    <FormGroup>
                                      <DebitCreditDrop
                                        control={control}
                                        placeholder="Select"
                                        name={`voucher_contra_partial_pay.${index}.type`}
                                        ref={el => (drCrRefs.current[index] = el)}
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors.voucher_contra_partial_pay?.[index]
                                            ?.type?.message
                                        }
                                      </FormFeedback>
                                    </FormGroup>
                                  </td>
                                  <td>
                                    <FormGroup>
                                      <UFInput
                                        control={control}
                                        placeholder="Code"
                                        name={`voucher_contra_partial_pay.${index}.code`}
                                        className="ps-1"
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors.voucher_contra_partial_pay?.[index]
                                            ?.code?.message
                                        }
                                      </FormFeedback>
                                    </FormGroup>
                                  </td>
                                  <td>
                                    <FormGroup>
                                      <UFDate
                                        control={control}
                                        placeholder="Select Date"
                                        name={`voucher_contra_partial_pay.${index}.date`}
                                        className="ps-1"
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors.voucher_contra_partial_pay?.[index]
                                            ?.date?.message
                                        }
                                      </FormFeedback>
                                    </FormGroup>
                                  </td>
                                  <td>
                                    <FormGroup>
                                      <UFDate
                                        control={control}
                                        placeholder="Select Date"
                                        name={`voucher_contra_partial_pay.${index}.due_date`}
                                        className="ps-1"
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors.voucher_contra_partial_pay?.[index]
                                            ?.due_date?.message
                                        }
                                      </FormFeedback>
                                    </FormGroup>
                                  </td>
                                  <td>
                                    <FormGroup>
                                      <UFInputNumber
                                        control={control}
                                        placeholder="Amount"
                                        name={`voucher_contra_partial_pay.${index}.amount`}
                                        className="ps-1"
                                        isDecimal={true}
                                        decimalLength={desimalrange || 2}
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors.voucher_contra_partial_pay?.[index]
                                            ?.amount?.message
                                        }
                                      </FormFeedback>
                                    </FormGroup>
                                  </td>
                                  <td>
                                    <div className="pb-1 px-2 d-flex justify-content-center">
                                      <div
                                        className="trash-img pointer"
                                        onClick={() => {
                                          contraPartialListRemove(index)
                                          handlePartialRemove(item?.voucher_entry_id)
                                        }}
                                      >
                                        <TrashIcon />
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            ))}
                          </tbody>
                        </table>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">Total</div>
                          </Col>
                          <Col lg="3" className="py-2">
                            {Number(watch("opening_balance")).toFixed(
                              desimalrange || 2
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">Debit</div>
                          </Col>
                          <Col lg="3" className="py-2">
                            {Number(
                              calculateCreditDebitDifference(
                                watch("voucher_contra_partial_pay") || []
                              )?.totalDebit
                            ).toFixed(desimalrange || 2)}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">Credit</div>
                          </Col>
                          <Col lg="3" className="py-2">
                            {Number(
                              calculateCreditDebitDifference(
                                watch("voucher_contra_partial_pay") || []
                              )?.totalCredit
                            ).toFixed(desimalrange || 2)}
                          </Col>
                        </Row>
                        {/* {[13, 15, 6, 1, 3, 8].includes(watch("voucher_id")?.value) && ( */}
                        {/* <div className="text-end mt-2 note-txt">
                                                Press TAB to handle Values
                                              </div> */}
                        {/* )} */}
                      </Col>
                      {/* <Col lg="12">
                                            {viewVouchersLi ? (
                                              <VoucherEntrySearch
                                                fromDashboard={true}
                                                editPartial={editPartial} // Added by Adithyan
                                                editId={editId} // Added by Adithyan
                                                handilUpdate={handilUpdate} // Added by Adithyan
                                                onSelect={handlePOSelect}
                                                voucherType={viewData?.voucher_type}
                                                ledgerId={viewData?.ledger_id}
                                                partialPayment={true}
                                                voucherLocation={watch("voucher_id")?.value}
                                              />
                                            ) : (
                                              <></>
                                            )}
                                          </Col> */}
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    <LoadingButton
                      form={formId}
                      color={"primary"}
                      loading={isLoading}
                      disabled={isLoading}
                      type="submit"
                    >
                      Save
                    </LoadingButton>
                  </ModalFooter>
                </div>
              </Modal>
            </Form>
          </FormProvider>
        </OffcanvasBody>
      )}
    </>
  )
}

const EditCustomer = ({
  buttonLabel,
  className,
  editValue,
  isOpen,
  onClose,
  onCustomerCreated,
  ...props
}) => {
  const [offcanvas, setOffcanvas] = useState(false)
  const [getEditValue, setGetEditValue] = useState("")
  const [customers, setCustomers] = useState([])

  const handleSuccess = newCustomerId => {
    onCustomerCreated?.(newCustomerId) // Call this when customer is successfully created
    onClose?.()
  }
  const toggle = () => {
    if (isOpen !== undefined) {
      onClose?.()
    } else {
      setOffcanvas(!offcanvas)
    }
  }

  const handleUpdateCustomerList = updatedList => {
    setCustomers(updatedList)
    if (props.onCustomerListUpdate) {
      props.onCustomerListUpdate(updatedList)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchCustomer(editValue?.id)
      if (response?.status) {
        setGetEditValue(response)
      }
    }
    if (editValue?.id) {
      toggle()
      fetchData()
    }
  }, [editValue?.id])

  const isOpenState = isOpen !== undefined ? isOpen : offcanvas

  return (
    <>
      {buttonLabel && (
        <Link to="#" className={className} onClick={toggle}>
          {buttonLabel}
        </Link>
      )}
      <Offcanvas
        isOpen={isOpenState}
        toggle={toggle}
        direction="end"
        className="w-of-70"
      >
        <Edit
          close={() => {
            toggle()
            setGetEditValue("")
            props?.onReset?.()
          }}
          getEditValue={getEditValue}
          updateCustomerList={handleUpdateCustomerList}
          onUpdate={handleSuccess}
          editValue={editValue}
          {...props}
        />
      </Offcanvas>
    </>
  )
}

export default EditCustomer
